import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Capacity from "./capacity";

const Container = styled.table``;

class Capacities extends React.Component {
  static propTypes = {
    capacities: PropTypes.array
  };

  render = () => {
    return (
      <Container>
        <thead><tr><th colSpan={2}></th></tr></thead>
        {this.props.capacities.map((capacity, idx) => {
          return (<tbody key={idx}>
            <Capacity capacity={capacity}></Capacity>
          </tbody>);
        })}
      </Container>
    );
  };
}

export default Capacities;
